<template>
	<div class="response__action">
		<b-card>
			<div slot="header">
				{{ $t( headTitle + ' Action') }}
				<label
					class="switch switch-sm switch-text switch-info float-right mb-0"
				>
					<input
						type="checkbox"
						v-model="data[fieldPrefix + '_status']"
						class="switch-input"
						@change="emitChange"
					/>
					<span class="switch-label" :data-on="$t('On')" :data-off="$t('Off')"></span>
					<span class="switch-handle"></span>
				</label>
			</div>
			<div v-if="!!data[fieldPrefix + '_status']">
				<p>{{ $t(headTitle + ' actions list') }}</p>
				<table class="table table-bordered table-striped table-sm">
					<thead>
						<tr>
							<th>{{ $t('Action Type') }}</th>
							<th>{{ $t('action') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(action, indexAction) in (data[fieldPrefix + 's'] || [])" :key="indexAction">
							<td>
								<template v-for="(type, i) in availableActions">
									<span :key="i" v-if="type.value == action[fieldPrefix + '_type']">{{$t(type.label)}}</span>
								</template>
							</td>
							<td class="text-center">
								<button type="button" class="btn btn-link p-0 mr-2">
									<i
										@click="responseAction = Object.assign(action, {index: indexAction})"
										class="fa fa-edit fa-lg"
										:title="$t('edit')"
									></i>
								</button>
								<button type="button" class="btn btn-link p-0 mr-2">
									<i @click="removeAction(indexAction)" class="fa fa-remove fa-lg" :title="$t('delete')"></i>
								</button>
							</td>
						</tr>
						<tr v-if="!(data[fieldPrefix + 's'] || []).length">
							<td colspan="2">
								<div class="text-center">{{ $t('no data') }}</div>
							</td>
						</tr>
					</tbody>
				</table>
				<hr />
				<tooltip :label="headTitle + ' action type'" placement="right">
					<select
						:name="fieldPrefix + '_type'"
						v-model="responseAction[fieldPrefix + '_type']"
						v-validate="'required'"
						:class="{'form-control': true, 'is-invalid': errors.has(fieldPrefix + '_type')}"
					>
						<option value disabled>{{ $t('Choose one') }}</option>
						<option v-for="(type, i) in actions" :key="i" :value="type.value">{{ $t(type.label) }}</option>
					</select>
					<span
						v-if="errors.has(fieldPrefix + '_type')"
						class="help is-danger invalid-feedback"
					>{{ $t(errors.first(fieldPrefix + '_type')) }}</span>
				</tooltip>
				<div v-if="responseAction[fieldPrefix + '_type'] == 'cs_connect' && departments.length">
					<tooltip label="select department" placement="right">
						<select
							:name="fieldPrefix + '_cs_connect_department'"
							v-model="responseAction[fieldPrefix + '_cs_connect_department']"
							:class="{'form-control': true}"
						>
							<option value>{{ $t('general connection ') }}</option>
							<option v-for="type in departments" :value="type.id" :key="type.id">{{ type.name }}</option>
						</select>
					</tooltip>
				</div>
				<div v-else-if="responseAction[fieldPrefix + '_type'] == 'mail'">
					<tooltip label="Mail Title" placement="right">
						<input
							:placeholder="$t('mail title')"
							:name="fieldPrefix + '_mail_title'"
							v-model="responseAction[fieldPrefix + '_mail_title']"
							v-validate="'required'"
							:class="{'form-control': true,'is-invalid': errors.has(fieldPrefix + '_mail_title')}"
						/>
						<span
							v-if="errors.has(fieldPrefix + '_mail_title')"
							class="help is-danger invalid-feedback"
						>{{ $t(errors.first(fieldPrefix + '_mail_title')) }}</span>
					</tooltip>
					<tooltip label="Mail Body" placement="right">
						<textarea
							:placeholder="$t('mail body')"
							:name="fieldPrefix + '_mail_msg'"
							v-model="responseAction[fieldPrefix + '_mail_msg']"
							:class="{'form-control': true, 'is-invalid': errors.has(fieldPrefix + '_mail_msg')}"
							v-validate="'required'"
							cols="5"
						></textarea>
						<span
							v-if="errors.has(fieldPrefix + '_mail_msg')"
							class="help is-danger invalid-feedback"
						>{{ $t(errors.first(fieldPrefix + '_mail_msg')) }}</span>
					</tooltip>
					<tooltip label="mails to" placement="right">
						<input-tag
							:class="{'form-control': true, 'is-invalid': errors.has(fieldPrefix + '_mail_to')}"
							:tags.sync="responseAction[fieldPrefix + '_mail_to']"
							:add-tag-on-keys="[13]"
							:placeholder="$t('Send to emails')"
							:limit="5"
							validate="email"
							v-model="responseAction[fieldPrefix + '_mail_to']"
						></input-tag>
						<input
							type="hidden"
							:name="fieldPrefix + '_mail_to'"
							v-validate="'required'"
							v-model="responseAction[fieldPrefix + '_mail_to']"
						/>
						<span
							v-if="errors.has(fieldPrefix + '_mail_to')"
							class="help is-danger invalid-feedback"
						>{{ $t(errors.first(fieldPrefix + '_mail_to')) }}</span>
					</tooltip>
				</div>
				<div v-else-if="responseAction[fieldPrefix + '_type'] == 'api'">
					<tooltip label="API URL" placement="right">
						<!-- v-validate="'required|url:require_protocol'" -->
						<input
							:name="fieldPrefix + '_api_url'"
							type="text"
							v-model="responseAction[fieldPrefix + '_api_url']"
							v-validate="'required'"
							:placeholder="$t('api url')"
							:class="{'form-control': true, 'is-invalid': errors.has(fieldPrefix + '_api_url')}"
						/>
						<span
							v-if="errors.has(fieldPrefix + '_api_url')"
							class="help is-danger invalid-feedback"
						>{{ $t(errors.first(fieldPrefix + '_api_url')) }}</span>
					</tooltip>
					<tooltip label="API Type" placement="right">
						<select
							:name="fieldPrefix + '_api_req_type'"
							v-model="responseAction[fieldPrefix + '_api_req_type']"
							v-validate="'required'"
							:class="{'form-control': true, 'is-invalid': errors.has(fieldPrefix + '_api_req_type')}"
							@change="handleOnChangeAPIType"
						>
							<option value disabled>{{ $t('Choose one') }}</option>
							<option value="get">GET</option>
							<option value="post">POST</option>
							<option value="pars">URL Parameters</option>
						</select>
						<span
							v-if="errors.has(fieldPrefix + '_api_req_type')"
							class="help is-danger invalid-feedback"
						>{{ $t(errors.first(fieldPrefix + '_api_req_type')) }}</span>
					</tooltip>
					<tooltip label="Custom Headers" placement="right">
						<textarea
							:name="fieldPrefix + '_api_headers'"
							cols="5"
							class="form-control"
							v-model="responseAction[fieldPrefix + '_api_headers']"
							:placeholder="$t('Type Custom Headers')"
						></textarea>
					</tooltip>
					<b-card>
						<p>{{ $t('api Parameters') }}</p>
						<table class="table table-bordered table-striped table-sm">
							<thead>
								<tr>
									<th>{{ $t('Parameter Name') }}</th>
									<th>{{ $t('Parameter Value') }}</th>
									<th>{{ $t('Parameter Default Value') }}</th>
									<th>{{ $t('action') }}</th>
								</tr>
							</thead>
							<tbody>
								<template
									v-if="Array.isArray(responseAction[fieldPrefix + '_api_pars'])
                    && responseAction[fieldPrefix + '_api_pars'].length"
								>
									<tr v-for="(par, index) in responseAction[fieldPrefix + '_api_pars']" :key="index">
										<td>{{ par.name }}</td>
										<td>{{ par.var_name ? (isSenderVariable(par) ? $t(par.var_name) : par.var_name) : 'NULL' }}</td>
										<td>{{ par.var_default_value ? par.var_default_value : 'NULL' }}</td>
										<td class="text-center">
											<button type="button" class="btn btn-link p-0 mr-2">
												<i
													class="fa fa-edit fa-lg"
													@click="apiParam = par;apiParam.index = index"
													:title="$t('edit')"
												></i>
											</button>
											<button type="button" class="btn btn-link p-0 mr-2">
												<i
													class="fa fa-remove fa-lg"
													@click="responseAction[fieldPrefix + '_api_pars'].splice(index, 1);apiParam.index = -1"
													:title="$t('delete')"
												></i>
											</button>
										</td>
									</tr>
								</template>
								<template v-else>
									<tr>
										<td colspan="3">
											<div class="text-center">{{ $t('no data') }}</div>
										</td>
									</tr>
								</template>
							</tbody>
						</table>
						<tooltip label="Parameter Name" placement="right">
							<input
								:name="fieldPrefix + '_api_par_name'"
								type="text"
								v-model="apiParam.name"
								:placeholder="$t('Parameter Name')"
								v-validate="'required'"
								:class="{'form-control': true, 'is-invalid': errors.has(fieldPrefix + '_api_par_name')}"
							/>
							<span
								v-if="errors.has(fieldPrefix + '_api_par_name')"
								class="help is-danger invalid-feedback"
							>{{ $t(errors.first(fieldPrefix + '_api_par_name')) }}</span>
						</tooltip>

						<template v-if="'pars' != responseAction[fieldPrefix + '_api_req_type']">
							<tooltip label="Parameter value" placement="right">
								<select
									:name="fieldPrefix + '_api_par_value'"
									:class="{'form-control': true, 'is-invalid': errors.has(fieldPrefix + '_api_par_value')}"
									v-model="apiParam.var_id"
									v-validate="''"
								>
									<option value disabled>{{ $t('Choose One') }}</option>
									<option v-for="(v, vi) in apiVariables" :key="vi" :value="v.var_id">{{ v.var_name }}</option>
									<template v-if="includeSenderInfo">
										<option
											class="hl-opt"
											v-for="(s, si) in Object.keys($store.state.sender_info)"
											:key="si"
											:value="s"
										>{{ $t($store.state.sender_info[s]) }}</option>
									</template>
								</select>
								<span
									v-if="errors.has(fieldPrefix + '_api_par_value')"
									class="help is-danger invalid-feedback"
								>{{ $t(errors.first(fieldPrefix + '_api_par_value')) }}</span>
							</tooltip>
							<tooltip label="Parameter default value" placement="right">
								<input
									:name="fieldPrefix + '_api_par_default_value'"
									type="text"
									v-model="apiParam.var_default_value"
									:placeholder="$t('Parameter default value')"
									v-validate="'required'"
									:class="{
                        'form-control': true,
                        'is-invalid': errors.has(fieldPrefix + '_api_par_default_value'),
                    }"
								/>
								<span
									v-if="errors.has(fieldPrefix + '_api_par_default_value')"
									class="help is-danger invalid-feedback"
								>{{ $t(errors.first(fieldPrefix + '_api_par_default_value')) }}</span>
							</tooltip>
						</template>

						<div class="form-actions">
							<button
								type="button"
								@click.prevent="handleOnClickApiParam"
								class="btn btn-primary btn-sm"
							>{{ $t(apiParam.index === -1 ? 'Add' : 'edit') }}</button>
						</div>
					</b-card>
				</div>
				<div class="form-actions">
					<button
						type="button"
						@click="handleOnClickResponseAction"
						class="btn btn-primary btn-sm"
					>{{ $t(responseAction.index > -1 ? 'Edit' : 'add') }}</button>
				</div>
			</div>
		</b-card>
	</div>
</template>

<script>
	import InputTag from 'vue-input-tag'
	export default {
		name: 'response-action',
		components: {
			InputTag,
		},
		props: {
			dataSet: {
				type: Object,
				default: () => ({
					[this.fieldPrefix + '_status']: false,
				}),
			},
			actions: {
				type: Array,
				default: () => [
					{
						label: 'Send Mail',
						value: 'mail',
					},
					{
						label: 'Send api',
						value: 'api',
					},
				],
			},
			customerSupportDepartments: {
				type: Array,
				default: () => [],
			},
			apiVariables: {
				type: Array,
				default: () => [],
			},
			includeSenderInfo: {
				type: Boolean,
				default: () => true,
			},
			headTitle: {
				type: String,
				default: () => '',
			},
			fieldPrefix: {
				type: String,
				required: true,
			},
		},
		data() {
			return {
				data: this.dataSet,
				availableActions: this.actions,
				departments: this.customerSupportDepartments,
				responseAction: {
					index: -1,
					[this.fieldPrefix + '_type']: '',
					[this.fieldPrefix + '_cs_connect_department']: '',
					[this.fieldPrefix + '_mail_title']: '',
					[this.fieldPrefix + '_mail_msg']: '',
					[this.fieldPrefix + '_mail_to']: [],
					[this.fieldPrefix + '_api_url']: '',
					[this.fieldPrefix + '_api_req_type']: '',
					[this.fieldPrefix + '_api_headers']: '',
					[this.fieldPrefix + '_api_pars']: [],
				},
				apiParam: {
					index: -1,
					name: '',
					var_id: '',
					var_default_value: '',
				},
			}
		},
		methods: {
			handleOnClickResponseAction() {
				this.validateAction().then((status) => {
					var action = this.responseAction

					if (parseInt(action.index) === -1) {
						// save new action
						this.data[this.fieldPrefix + 's'] = (this.data[this.fieldPrefix + 's'] || []).concat(
							this.cleanAction(action)
						)
					} else {
						// edit action exist
						if ((this.data[this.fieldPrefix + 's'] || []).indexOf(action.index) >= 0) {
							this.data[this.fieldPrefix + 's'][action.index] = this.cleanAction(action)
						}
					}
					this.resetAction()
					this.validatorReset()
					this.emitChange()
				})
			},

			handleOnClickApiParam() {
				var param = this.apiParam

				var fields = [this.fieldPrefix + '_api_par_name', this.fieldPrefix + '_api_par_value']

				this.$validator.validateAll(fields).then((isValid) => {
					if (isValid) {
						var paramCopy = {
							name: param.name,
							var_id: param.var_id,
							var_default_value: param.var_default_value || '',
						}
						if (this.$store.state.sender_info.hasOwnProperty(paramCopy.var_id)) {
							paramCopy.var_name = this.$store.state.sender_info[paramCopy.var_id]
						} else {
							if (this.includeSenderInfo) {
								// set default var
								for (var _i in this.apiVariables) {
									if (this.apiVariables[_i].var_id == paramCopy.var_id) {
										paramCopy.var_name = this.apiVariables[_i].var_name
										break
									}
								}
							}
						}
						if (parseInt(param.index) === -1) {
							this.responseAction[this.fieldPrefix + '_api_pars'] = (
								this.responseAction[this.fieldPrefix + '_api_pars'] || []
							).concat(paramCopy)
						} else {
							if (this.responseAction[this.fieldPrefix + '_api_pars'][param.index]) {
								this.responseAction[this.fieldPrefix + '_api_pars'][param.index] = paramCopy
							}
						}

						this.apiParam = {
							index: -1,
							name: '',
							var_id: '',
							var_default_value: '',
						}

						this.validatorReset()
					}
				})
			},
			isSenderVariable({var_id}) {
				if (this.includeSenderInfo) {
					return var_id && Object.keys(this.$store.state.sender_info).indexOf(var_id) >= 0
				}
				return false
			},
			validateAction() {
				var action = this.responseAction
				// console.log(action)
				return Promise.all([
					new Promise((resolve, reject) => {
						this.$validator.validateAll([this.fieldPrefix + '_type']).then((success) => {
							if (success) {
								var fields = (() => {
									switch (action[this.fieldPrefix + '_type']) {
										case 'mail':
											return [
												this.fieldPrefix + '_mail_title',
												this.fieldPrefix + '_mail_msg',
												this.fieldPrefix + '_mail_to',
											]
										case 'api':
											return [this.fieldPrefix + '_api_url', this.fieldPrefix + '_api_req_type']
										default:
											return null
									}
								})()
								// console.log(fields)
								if (fields && fields.length) {
									this.$validator.validateAll(fields).then((success) => {
										if (success) {
											resolve(true)
										} else {
											reject('Validation error')
										}
									})
								} else {
									resolve(true)
								}
							} else {
								reject('Validation error')
							}
						})
					}),
					new Promise((resolve, reject) => {
						if (
							!this.inResponseAction(
								action[this.fieldPrefix + '_type'],
								(this.data[this.fieldPrefix + 's'] || []).slice()
							)
						) {
							resolve(true)
						} else {
							reject('action is already used!')
						}
					}),
				])
			},
			inResponseAction(action, actions) {
				// create logic here to check if response not exist
				return false
			},
			resetAction() {
				// reset action form value
				this.responseAction = {
					index: -1,
					[this.fieldPrefix + '_type']: '',
					[this.fieldPrefix + '_cs_connect_department']: '',
					[this.fieldPrefix + '_mail_title']: '',
					[this.fieldPrefix + '_mail_msg']: '',
					[this.fieldPrefix + '_mail_to']: [],
					[this.fieldPrefix + '_api_url']: '',
					[this.fieldPrefix + '_api_req_type']: '',
					[this.fieldPrefix + '_api_headers']: '',
					[this.fieldPrefix + '_api_pars']: [],
				}
			},
			removeAction(index) {
				if (this.data[this.fieldPrefix + 's'][index]) {
					this.data[this.fieldPrefix + 's'].splice(index, 1)
					this.resetAction()
					this.emitChange()
				}
			},
			handleOnChangeAPIType() {
				if ('pars' == this.responseAction[this.fieldPrefix + '_api_req_type']) {
					this.responseAction[this.fieldPrefix + '_api_pars'] = (
						this.responseAction[this.fieldPrefix + '_api_pars'] || []
					).reduce(function(a, b) {
						return a.concat({
							...b,
							var_default_value: null,
							var_id: null,
						})
					}, [])
					// console.log(this.responseAction)
				}
			},
			emitChange() {
				this.$emit('change', this.data)
			},
			validatorReset() {
				try {
					this.$validator.reset()
				} catch (error) {
					console.log(error)
				}
			},
			cleanAction(action) {
				var actionCopy = clone(action)
				delete actionCopy.index
				return actionCopy
			},
			column(key) {
				return this.fieldPrefix + key
			},
		},
		watch: {
			dataSet: {
				handler(val) {
					this.data = val
				},
				deep: true,
			},
			actions: {
				handler(val) {
					this.availableActions = val
				},
				deep: true,
			},
			customerSupportDepartments: {
				handler(val) {
					this.departments = val
				},
				deep: true,
			},
			apiParameterVariables: {
				handler(val) {
					this.apiVariables = val
				},
				deep: true,
			},
		},
	}
</script>
